<template>
  <b-container>
    <b-row>
      <b-col cols="12">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h3 class="font-weight-bold">Daily Files</h3>
            <small class="text-muted">
              Daily summary reports and data exports
            </small>
          </div>

          <div class="d-flex align-items-center">
            <flat-pickr
              :value="rangeTime"
              id="range-picker"
              class="form-control"
              :config="configDate"
              placeholder="mm/dd/yyyy"
              @input="(val) => (this.rangeTime = val)"
            />
            <b-button variant="primary" class="text-nowrap ml-1">
              <feather-icon icon="RotateCcwIcon" />
              Regenerate
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <b-col cols="12" class="bg-white p-0 shadow-lg rounded">
        <div class="d-flex justify-content-between px-2 py-1 border-bottom">
          <strong class="font-weight-bolder mb-0 text-capitalize">
            Daily Reports - January 2026
          </strong>
        </div>
        <div
          v-for="(file, index) in files"
          :key="index"
          class="file-row d-flex justify-content-between align-items-center px-2 py-2"
        >
          <div class="d-flex align-items-center">
            <div class="file-icon mr-1">
              <feather-icon icon="FileTextIcon" size="18" />
            </div>

            <div>
              <div class="font-weight-semibold">
                {{ file.name }}
              </div>
              <small class="text-muted">
                {{ file.meta }}
              </small>
            </div>
          </div>

          <div>
            <b-button size="sm" variant="outline-secondary" class="mr-1">
              <feather-icon icon="EyeIcon" size="14" />
              View
            </b-button>

            <b-button size="sm" variant="primary">
              <feather-icon icon="DownloadIcon" size="14" />
              Download
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { BContainer, BRow, BCol, BCard, BButton, BLink } from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BButton,
    BLink,
    flatPickr,
  },
  data() {
    return {
      rangeTime: null,
      configDate: {
        mode: "range",
        altFormat: "d-m-Y",
        altInput: true,
      },
      files: [
        {
          name: "all_bets_2026-01-06_hourly_12.csv",
          meta: "Generated: Today 12:00 PM • 45.2 MB • 128,456 records",
        },
        {
          name: "all_bets_2026-01-06_hourly_11.csv",
          meta: "Generated: Today 11:00 AM • 42.1 MB • 118,234 records",
        },
        {
          name: "all_bets_2026-01-06_hourly_10.csv",
          meta: "Generated: Today 10:00 AM • 38.7 MB • 105,892 records",
        },
        {
          name: "all_bets_2026-01-06_full.xlsx",
          meta: "Generated: Today 12:00 PM • 156.4 MB • Full day export",
        },
      ],
    };
  },
  methods: {
    handleChangeMonth(month) {
      if (!month) return;
      const isActive = month.id === this.monthActive.id;
      if (isActive) return;
      const monthDetail = this.months.find((m) => m.id === month.id);
      if (monthDetail) this.monthActive = monthDetail;
    },
  },
};
</script>

<style lang="scss" scoped>
.archive-page {
  background: #f8fafc;
  min-height: 100vh;
}

.archive-tabs {
  .tab {
    flex: 1;
    text-align: center;
    padding: 18px 12px;
    cursor: pointer;
    font-weight: 600;
  }
  .active {
    border-bottom: 2px solid #3b82f6;
    color: #3b82f6;
  }
}

.month-item {
  padding: 16px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: 0.2s;
  &:hover {
    background: #f9fafb;
  }
  &.active {
    background: #eef2ff;
    border-left: 3px solid #3b82f6;
  }
}
.file-row {
  border-bottom: 1px solid #f1f1f1;

  &:hover {
    background: #fafafa;
  }
}
.file-icon {
  width: 36px;
  height: 36px;
  background: #eef2ff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
